module.exports = __webpack_public_path__ + "static/media/mkpp.476f9511.jpg";